export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_PARTY_FILTERS': {
      return {
        ...state,
        partyFilters: action.data,
      };
    }
    case 'SET_PARTY_FILTER_FLAG': {
      return {
        ...state,
        activeFilter: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
